import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { useLanguageContext } from "../context/LanguageContext";
import supabase from "../services/supabaseClient";

const Header: React.FC = () => {
  const { isHE, setIsHE } = useLanguageContext();
  const [menuOpen, setMenuOpen] = useState(false);
  const [logoURL, setLogoURL] = useState<string | undefined>("../assets/logo.png");

  const fetchLogoURL = async (): Promise<string | null> => {
    try {
      const { data } = supabase
        .storage
        .from('otherFiles')
        .getPublicUrl('logo.png');
      return data?.publicUrl || null;
    } catch (err) {
      console.error("Unexpected error fetching logo URL:", err);
      return null;
    }
  };

  useEffect(() => {
    const fetchLogoImg = async () => {
      const cachedLogo = localStorage.getItem('logoUrl');
      if (cachedLogo) {
        setLogoURL(cachedLogo);
      } else {
        const photo = await fetchLogoURL();
        if (photo) {
          setLogoURL(photo);
          localStorage.setItem('logoUrl', photo);
        } else {
          setLogoURL("../assets/logo.png");
        }
      }
    };
    fetchLogoImg();
  }, []);

  useEffect(() => {
    setMenuOpen(true);
    setTimeout(() => {
      setMenuOpen(false);
    }, 4000)
  }, [isHE]);

  return (
    <header
      className="sticky top-0 h-1/6 text-white shadow-elevation border-b border-gray-500"
      style={{ backgroundColor: "#173E70", zIndex: 10 }}
    >
      <div className="w-full py-2 flex justify-between items-center px-4">
        {/* Logo */}
        <Link to="/" className="flex items-center">
          <img
            src={logoURL}
            alt="Site Logo"
            className="h-20 w-auto object-contain"
          />
        </Link>

        {/* Hamburger Menu for Mobile */}
        <button
          className="md:hidden focus:outline-none text-gray-300"
          onClick={() => setMenuOpen((prev) => !prev)}
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>

        {/* Desktop Navigation Links */}
        <nav className="hidden md:flex space-x-8">
          <Link
            to="/boards"
            className="hover:text-gray-300 transition text-lg"
          >
            {isHE ? "דירוג מומחי דראפט" : "Draft Gurus Board"}
          </Link>
          <Link
            to="/prospects"
            className="hover:text-gray-300 transition text-lg"
          >
            {isHE ? "טרמינל הפרוספקטים" : "Prospects Terminal"}
          </Link>
          <Link
            to="/big-board-mocks"
            className="hover:text-gray-300 transition text-lg"
          >
            {isHE ? "ביג בורד ומוקים" : "Big Board & Mock Drafts"}
          </Link>
          <Link
            to="/redrafts"
            className="hover:text-gray-300 transition text-lg"
          >
            {isHE ? "רי-דראפטים" : "Redrafts"}
          </Link>
        </nav>

        {/* Language Toggle Button */}
        <div className="hidden md:flex items-center space-x-2">
          <div className="text-xs mt-0.5">Set language to:&nbsp;</div>
          <button
            onClick={() => setIsHE((prev) => !prev)}
            className="bg-gray-800 px-4 py-2 rounded-xl shadow-elevation hover:bg-gray-600 transition active:scale-95"
          >
            {isHE ? "EN" : "HE"}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div
          className="md:hidden text-white"
        >
          <nav
            dir={isHE ? "rtl" : "ltr"}
            className="absolute top-12 left-0 w-full bg-gray-800/95 backdrop-blur-md flex flex-col space-y-4 px-4 py-4 rounded-b-2xl shadow-elevation-lg text-start"
          >
            <button
              onClick={() => {
                setIsHE((prev) => !prev);
                setMenuOpen(false);
              }}
              className="bg-gray-700 px-4 py-2 rounded-xl shadow-elevation hover:bg-gray-600 transition active:scale-95 w-full text-center"
            >
              Set language to:&nbsp;
              {isHE ? "EN" : "HE"}
            </button>
            <Link
              to="/prospects"
              className="hover:text-gray-300 transition text-lg"
              onClick={() => setMenuOpen(false)}
            >
              {isHE ? "טרמינל הפרוספקטים" : "Prospects Terminal"}
            </Link>
            <Link
              to="/big-board-mocks"
              className="hover:text-gray-300 transition text-lg"
              onClick={() => setMenuOpen(false)}
            >
              {isHE ? "ביג בורד ומוקים" : "Big Board & Mock Drafts"}
            </Link>
            <Link
              to="/boards"
              className="hover:text-gray-300 transition text-lg"
              onClick={() => setMenuOpen(false)}
            >
              {isHE ? "דירוג מומחי דראפט" : "Draft Gurus Board"}
            </Link>
            <Link
              to="/redrafts"
              className="hover:text-gray-300 transition text-lg"
              onClick={() => setMenuOpen(false)}
            >
              {isHE ? "רי-דראפטים" : "Redrafts"}
            </Link>

          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
